import React from 'react';
import { Switch } from '@headlessui/react';

const DisplayOptions = ({ showMonthHeaders, setShowMonthHeaders }) => {
  return (
    <div>
      <h3 className="text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Display Options</h3>
      <div className="mt-1 space-y-4">
        {/* Month Headers Toggle Switch */}
        <div className="flex items-center">
          <Switch
            checked={showMonthHeaders}
            onChange={setShowMonthHeaders}
            className="group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 focus:outline-hidden"
          >
            <span className="sr-only">Group by Starting Month</span>
            <span aria-hidden="true" className="pointer-events-none absolute size-full rounded-md bg-white" />
            <span
              aria-hidden="true"
              className={`pointer-events-none absolute mx-auto h-4 w-9 rounded-full ${
                showMonthHeaders ? 'bg-indigo-600' : 'bg-gray-200 dark:bg-gray-700'
              } transition-colors duration-200 ease-in-out`}
            />
            <span
              aria-hidden="true"
              className={`pointer-events-none absolute left-0 inline-block size-5 transform rounded-full border border-gray-200 bg-white shadow-sm ring-0 transition-transform duration-200 ease-in-out ${
                showMonthHeaders ? 'translate-x-5' : 'translate-x-0'
              }`}
            />
          </Switch>
          <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-100">
            Group by Starting Month
          </span>
        </div>
      </div>
    </div>
  );
};

export default DisplayOptions;